import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import TextField from './input/fields/text-field';
import { Checkbox } from 'primereact/checkbox';

const Newsletter = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [accepted, setAccepted] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [response, setResponse] = useState(null);

  const [isMobileTablet, setIsMobileTablet] = useState(window.matchMedia("(max-width: 991px)").matches);
  const { t } = useTranslation();

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    
    if (!name || !email || !accepted) {
      setResponse({ message: t("Please fill out all required fields."), success: false });
      setIsDisabled(false);
      return;
    }
    try {
      const response = await fetch(process.env.REACT_APP_SITE_URL + "PageBE/SubscribeNewsletter", {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Name: name,
          Email: email,
          Accepted: accepted
        }),
      });

      if (response.ok) {
        setResponse({ message: t("SubscribedSuccessfully"), success: true });
      } else {
        setResponse({ message: t("SubscriptionFailed"), success: false });
      }
    } catch (error) {
      setResponse({ message: t("SubscriptionError"), success: false });
    } finally {
      setIsDisabled(false);
    }
  };

  return (
    <section className="background-black container-newsletter">
      <h4 className="title pt-5 mb-0 text-left pb-5 background-black text-white text-uppercase">{t("Newsletter")}</h4>
      <div className="d-flex row pt-5 me-0">
        <div className="col-lg-5 col-12">
          <div className="d-flex flex-column">
            <TextField
              className={"pr-6 placeholder-uppercase"}
              inputClassName={"input-black w-100 "}
              value={name}
              placeholder={t("FirstName") + "*"}
              onChange={(e) => setName(e.target.value)}
            />
            {!isMobileTablet && (
              <div className="d-flex text-white">
                <input type="checkbox" className="m-0 me-2" checked={accepted} onClick={() => setAccepted(!accepted)} />
                <div className="mt-2 fs-14" dangerouslySetInnerHTML={{ __html: t("TermsConditionsHtmlWhite") }} />
              </div>
            )}
          </div>
        </div>

        <div className="col-lg-5 col-12">
          <div className="d-flex flex-column">
            <TextField
              className={"pr-6 pt-5 pt-lg-0 placeholder-uppercase"}
              inputClassName={"input-black w-100 "}
              value={email}
              placeholder={t("Email") + "*"}
              onChange={(e) => setEmail(e.target.value)}
            />
            {isMobileTablet && (
              <div className="d-flex text-white">
                <input type="checkbox" className="m-0 me-4" checked={accepted} onClick={() => setAccepted(!accepted)} />
                <div className="mt-4 fs-14" dangerouslySetInnerHTML={{ __html: t("TermsConditionsHtmlWhite") }} />
              </div>
            )}
          </div>
        </div>

        <div className="col-lg-2 col-12 mt-5 mt-lg-0 pe-0 d-flex container-cta-newsletter">
          <button
            className="bg-transparent text-white text-left border-none arrowEffectContainer input-group-text nav-link effectArrow ctaWidthMax115 ctaLink text-uppercase pe-5"
            onClick={handleFormSubmit}
            disabled={isDisabled}
          >
            {t("Subscribe")} <FontAwesomeIcon className="paddingArrow effectArrow" icon={faArrowRight} />
          </button>
        </div>
      </div>

      {response && (
        <div className={`mt-4 ${response.success ? 'text-success' : 'text-danger'}`}>
          <p>{response.message}</p>
        </div>
      )}
    </section>
  );
};

export default Newsletter;
